import { createContext } from "react";
import { classList } from "../../../pages/Admin/Classrooms/data"

export const listControllerContext = createContext();
